module.exports = __webpack_public_path__ + "img/unlimited.e45a24e6.svg";